import { Popover } from 'antd';
import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { hasBillFileType, getBillFile, hasSignedContractFileType } from '../../../functions';
import api from '../../../api/api';

function LeadProgress({ lead, children, className }) {
  const { t } = useTranslation();
  function hasSiteSurveyedScheduled() {
    return (lead?.siteSurveyDateScheduled && !lead?.siteSurveyDate) || _.filter(lead?.appointments, (a) => a.type === 4 && a.appointmentStatus === 0).length > 0
  }
  function hasSiteSurveyed() {
    return (lead?.siteSurveyDate) || _.filter(lead?.appointments, (a) => a.type === 4 && a.appointmentStatus === 1).length > 0
  }
  function hasInstallationScheduled() {
    return (lead?.installationDateScheduled && !lead?.installationDate) || _.filter(lead?.appointments, (a) => a.type === 8 && a.appointmentStatus === 0).length > 0
  }
  function hasInstallation() {
    return (lead?.installationDate) || _.filter(lead?.appointments, (a) => a.type === 8 && a.appointmentStatus === 1).length > 0
  }
  return (
    <div className={className}>
      <div className="flex items-center space-x-2">
        <Popover content={t('bill')}>
          <div>
            {hasBillFileType(lead?.files, t) && (
              <button
                type="button"
                className={`rounded rounded-full px-2 text-white text-center h-8 w-8 ${hasBillFileType(lead?.files, t) ? 'bg-green-600' : 'bg-gray-300'}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (getBillFile(lead?.files, t)?.fileName?.includes('.pdf')) {
                    const elems = getBillFile(lead?.files, t)?.attachmentUrl.split('/');
                    api.get(`leads/file?fileName=${elems[elems.length - 1]}`, { responseType: 'blob' })
                      .then((response) => {
                        const file = new Blob([response.data], { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL, '_blank');
                      }).catch((error) => {
                        console.log(error);
                      });
                  } else {
                    window.open(getBillFile(lead?.files, t)?.attachmentUrl, '_blank');
                  }
                }}
              >
                B
              </button>
            )}
            {!hasBillFileType(lead?.files, t) && (
              <div className="rounded rounded-full pt-1 pl-2 pr-2 text-white text-center h-8 w-8 bg-gray-300">B</div>
            )}
          </div>
        </Popover>
        <Popover content={t('appointment')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 w-8 ${lead?.appointmentDateTime ? 'bg-green-600' : 'bg-gray-300'}`}>A</span>
        </Popover>
        <Popover content={t('contract_signed')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 ${lead?.signedDate && hasSignedContractFileType(lead?.files, t) ? 'bg-green-600' : lead?.signedDate && !hasSignedContractFileType(lead?.files, t) ? 'bg-green-400 border border-dashed' : 'bg-gray-300'}`}>CS</span>
        </Popover>
        <Popover content={t('site_surveyed')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 ${hasSiteSurveyed() ? 'bg-green-600' : hasSiteSurveyedScheduled() ? 'bg-green-400 border border-dashed' : 'bg-gray-300'}`}>SS</span>
        </Popover>
        <Popover content={t('installation')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 w-8 ${hasInstallation() ? 'bg-green-600' : hasInstallationScheduled() ? 'bg-green-400 border border-dashed' : 'bg-gray-300'}`}>I</span>
        </Popover>
        <Popover content={t('activation')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 w-8 ${lead?.activationDate ? 'bg-green-600' : 'bg-gray-300'}`}>A</span>
        </Popover>
        {/* <Popover content={t('payout')}>
          <span className={`rounded rounded-full pt-1 px-2 text-white text-center h-8 w-8 ${lead?.payoutDate ? 'bg-green-600' : 'bg-gray-300'}`}>P</span>
        </Popover> */}
        {children}
      </div>
    </div>
  );
}

export default LeadProgress;
